import { http, HttpResponse } from 'msw';
import {
  mockedGdprReport,
  mockedMapFile,
  mockedPairingResponse,
  mockedRemoteDebugSessions,
  mockedStatus,
  mockedTwin,
  mockedAllowedInLiveTrue,
  mockedAllowedInLiveFalse,
  mockedError,
  mockedTimeOut,
  mockedstartedAtTimestampZero,
  mockedstartedAtTimestampStarted,
  mockedTwinExistsIsTrue,
  mockedTwinExistsIsFalse,
  mockedCommand,
  mockedElasticSearchLogs,
} from './mockData';

localStorage.setItem('getRemoteDebugSession', 0);

localStorage.setItem('retryMowerLogIn', 0);

const prefix = '/tools/v1';
export const handlers = [
  http.get(`${prefix}/mowers/:mowerId/status`, () => {
    return HttpResponse.json(mockedStatus, { status: 200 });
  }),

  http.get(`${prefix}/mowers/:mowerId/twin`, () => {
    return HttpResponse.json(mockedTwin, { status: 200 });
  }),

  http.delete(`${prefix}/mowers/:mowerId/twin`, () => {
    return HttpResponse.json({ message: 'OK' }, { status: 200 });
  }),

  http.post(`${prefix}/gdpr`, () => {
    return HttpResponse.json(mockedGdprReport, { status: 200 });
  }),

  http.get(`${prefix}/mowers/:mowerId/map`, () => {
    return HttpResponse.json(mockedMapFile, { status: 200 });
  }),

  http.post(`${prefix}/mowers/pairing`, () => {
    return HttpResponse.json(mockedPairingResponse, { status: 200 });
  }),

  http.get(`${prefix}/mowers/remote-debug-sessions`, () => {
    return HttpResponse.json(mockedRemoteDebugSessions, { status: 200 });
  }),

  http.get(`${prefix}/mowers/:mowerId-999999999/twin/exists`, ({ params }) => {
    const { mowerId } = params;

    if (mowerId === '987654321') {
      return HttpResponse.json(mockedTwinExistsIsFalse, { status: 200 });
    }
    if (mowerId === '999999999') {
      return HttpResponse.json(mockedError, { status: 500 });
    }
    return HttpResponse.json(mockedTwinExistsIsTrue, { status: 200 });
  }),

  http.post(`${prefix}/mowers/:serialNumber-999999999/remoteDebugSession`, ({ params }) => {
    const { serialNumber } = params;

    if (serialNumber === '456789123') {
      return HttpResponse.json(mockedError, { status: 500 });
    }
    return HttpResponse.json({ message: 'OK' }, { status: 200 });
  }),

  http.post(`${prefix}/mowers/mowerGatewayDebugging`, async ({ request }) => {
    const device = await request.json();
    const { deviceId } = device;
    
    if (deviceId === '999999999-999999999') {
      return HttpResponse.json({ message: 'OK' }, { status: 200 });
    }
    return HttpResponse.json(mockedError, { status: 500 });
  }),

  http.get(`${prefix}/mowers/:serialNumber-999999999/remote-debug-session`, ({ params }) => {
    const { serialNumber } = params;

    if (serialNumber === '567891234' && localStorage.getItem('getRemoteDebugSession') < 15) {
      localStorage.setItem(
        'getRemoteDebugSession',
        +localStorage.getItem('getRemoteDebugSession') + 1,
      );
      return HttpResponse.json(mockedstartedAtTimestampZero, { status: 200 });
    }

    if (serialNumber === '567891244') {
      return HttpResponse.json(mockedstartedAtTimestampZero, { status: 200 });
    }

    if (serialNumber === '678912345') {
      return HttpResponse.json(mockedError, { status: 500 });
    }

    localStorage.setItem('getRemoteDebugSession', 0);
    return HttpResponse.json(mockedstartedAtTimestampStarted, { status: 200 });
  }),

  http.get(`${prefix}/mowers/:serialNumber-999999999/allowed-in-live`, ({ params }) => {
    const { serialNumber } = params;

    if (serialNumber === '123456789') {
      return HttpResponse.json(mockedError, { status: 500 });
    }
    if (serialNumber === '234567891') {
      return HttpResponse.json(mockedAllowedInLiveFalse, { status: 200 });
    }
    return HttpResponse.json(mockedAllowedInLiveTrue, { status: 200 });
  }),

  http.post(`${prefix}/mowers/proxyincloud/ownership`, async ({ request }) => {
    const device = await request.json();
    const { serialNumber } = device;

    if (serialNumber === 345678912) {
      return HttpResponse.json(mockedError, { status: 500 });
    }

    return HttpResponse.json({ message: 'OK' }, { status: 200 });
  }),

  http.post(`${prefix}/mowers/:serialNumber-999999999/proxyincloud/mower-log-in`, async ({ params }) => {
      const { serialNumber } = params;

      if (serialNumber === '395678912') {
        return HttpResponse.json(mockedError, { status: 404 });
      }
      if (serialNumber === '222222222') {
        return HttpResponse.json(mockedError, { status: 500 });
      }
      if (localStorage.getItem('retryMowerLogIn') < 1) {
        localStorage.setItem('retryMowerLogIn', +localStorage.getItem('retryMowerLogIn') + 1);
        return HttpResponse.json(mockedTimeOut, { status: 504 });
      }
      if (localStorage.getItem('retryMowerLogIn') < 3) {
        localStorage.setItem('retryMowerLogIn', +localStorage.getItem('retryMowerLogIn') + 1);
        return HttpResponse.json(mockedError, { status: 500 });
      }

      localStorage.setItem('retryMowerLogIn', 0);
      return HttpResponse.json({ message: 'OK' }, { status: 200 });
    },
  ),

  http.put(`${prefix}/mowers/:serialNumber-999999999/proxyincloud/amc-backend-host`, ({ params }) => {
      const { serialNumber } = params;

      if (serialNumber === '912345678') {
        return HttpResponse.json(mockedError, { status: 500 });
      }
      return HttpResponse.json({ message: 'OK' }, { status: 200 });
    },
  ),

  http.get(`${prefix}/mowers/:serialNumber-999999999/proxyincloud/amc-backend-reconnect`, ({ params }) => {
      const { serialNumber } = params;
      if (serialNumber === '112345678') {
        return HttpResponse.json(mockedError, { status: 500 });
      }
      return HttpResponse.json({ message: 'OK' }, { status: 200 });
    }, 
  ),

  http.post(`${prefix}/mowers/gatewaySendCommand`, async ({ request }) => {
    const deviceCommand = await request.json();
    const { deviceId, command } = deviceCommand;

    if (deviceId === '999999999-999999999' && command === 'MowerApp.Error(awaiting:false)') {
      return HttpResponse.json(mockedCommand, { status: 200 });
    }
    
    return HttpResponse.json(mockedError, { status: 500 });
    }
  ),

  http.post(`${prefix}/mowers/fetchElasticSearchLogs`, async ({ request }) => {
    const deviceLogs = await request.json();
    const { deviceId, startTime, endTime, environment } = deviceLogs;

    if (deviceId === '999999999-999999999' && startTime === '2025-04-22T06:00:00.000Z' && endTime === '2025-04-24T08:00:00.000Z' && environment === 'qa') {
      return HttpResponse.json(mockedElasticSearchLogs, { status: 200 });
    }
    
    return HttpResponse.json(mockedError, { status: 500 });
    }
  )
]; 
